import React, { useRef, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";

import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import "./Preview.scss";
import IconButton from "@material-ui/core/IconButton";
import { PreviewEndPoint } from "../../services/axiosConfig";
// import CloseIcon from "@material-ui/icons/Close";
import Refresh from "../../images/Refresh.svg";
import NewSlideRightArrowIcon from "../../images/Preview-Right-Arrow.svg";
// import NewSlideLeftArrowIcon from "../../images/Preview-Left-Arrow.svg";
import CancelIcon from "../../images/CancelIcon.svg";
import previewDownArrow from "../../images/edetail-v-down.svg";
import previewUpArrow from "../../images/edetail-v-up.svg";
import previewRightArrow from "../../images/edetail-h-r.svg";
import previewLeftArrow from "../../images/edetail-h-l.svg";
import expiredRestrictedIcon from "../../images/expired-restriction-icon.svg";
import { convertInDate } from "../../utils";
import CircularProgressBar from "../../utils/CircularProgressBar";

export default function PreviewModal({
  showPreview,
  setShowPreView,
  setLoading,
  deckData,
  slideID,
  currentSlide,
  lastChild,
  inParent,
  appData,
  previewLoading,
  previewUrlReady = false,
}) {
  const [currentURL, SetCurrentURL] = React.useState(null);
  const [previewCurrentSlide, setPreviewCurrentSlide] = React.useState({
    master: slideID[0],
    child: {},
  });
  const [canvasHeight, SetCanvasHeight] = React.useState(1);
  const sectionElement = React.useCallback((ref) => {
    let canvasHeight = ref?.getBoundingClientRect().height / (768 + 100);
    SetCanvasHeight(canvasHeight > 1 ? 1 : canvasHeight);
  }, []);

  React.useEffect(() => {
    // setPreviewCurrentSlide({ master: slideID[0], child: {} });
    setPreviewCurrentSlide({ master: currentSlide.master, child: {} });
  }, []);

  // Use deckData.name as fallback if appData.deckId.name is not available
  let DeckName = (appData?.deckId?.name || deckData?.name || "").replace(
    / /g,
    "_"
  );
  // let DeckName = deckData?.name.replace(/ /g, "_");

  React.useEffect(() => {
    // Only set URL after API call completes successfully
    if (previewUrlReady && showPreview) {
      const user = localStorage?.getItem("userId") || "";
      appData["userSub"] = user;
      let SlideName = (currentSlide.master?.slideid?.name || "Slide1").replace(
        / /g,
        "_"
      );

      // Ensure DeckName is not empty
      const finalDeckName =
        DeckName || (deckData?.name || "Deck").replace(/ /g, "_");

      SetCurrentURL(
        `${PreviewEndPoint}preview/${appData.userSub}/${finalDeckName}/${SlideName}/index.html`
      );
    } else {
      // Clear URL if not ready to prevent showing cached content
      SetCurrentURL(null);
    }
  }, [previewUrlReady, showPreview]);

  const handleCloseExport = () => {
    setShowPreView(false);
    // Reset URL when closing to prevent showing cached content on next open
    SetCurrentURL(null);
  };
  // const refreshIframe = () => {
  //   //document.getElementById("FrameID").src += "";
  // };

  const lastPage = () => {
    return slideID?.length > 0
      ? slideID[slideID.length - 1].slideid?._id ===
          previewCurrentSlide.master.slideid?._id
      : false;
  };
  const firstPage = () => {
    return slideID?.length > 0
      ? slideID[0].slideid?._id === previewCurrentSlide?.master?.slideid?._id
      : false;
  };
  const handleParent = () => {
    let nextIndex = previewCurrentSlide.master?.index;
    if (nextIndex === slideID.length) return;
    setPreviewCurrentSlide({
      master: slideID[nextIndex],
      child: {},
    });
    let slidename = slideID[nextIndex].slideid.name.replace(/ /g, "_");

    // console.log("nextPageName=", slideID[nextIndex].slideid.name);
    // SetCurrentURL(
    //   `${PreviewEndPoint}preview/${userSub}/${appData?.deckId?.name}/${slidename}/${slidename}.html`
    // );

    const deckName = (
      appData?.deckId?.name ||
      deckData?.name ||
      "Deck"
    ).replace(/ /g, "_");
    SetCurrentURL(
      `${PreviewEndPoint}preview/${appData.userSub}/${deckName}/${slidename}/index.html`
    );
  };
  const gotoPrevious = () => {
    let prevIndex = previewCurrentSlide?.master?.index - 2;
    if (prevIndex < 0) return;
    setPreviewCurrentSlide({
      master: slideID[prevIndex],
      child: {},
    });
    let slidename = (slideID[prevIndex]?.slideid?.name || "Slide1").replace(
      / /g,
      "_"
    );
    // console.log("nextPageName=", slideID[prevIndex]?.slideid?.name);

    const deckName = (
      appData?.deckId?.name ||
      deckData?.name ||
      "Deck"
    ).replace(/ /g, "_");
    SetCurrentURL(
      `${PreviewEndPoint}preview/${appData.userSub}/${deckName}/${slidename}/index.html`
    );
  };

  const gotoFirstAndNextChild = () => {
    let currentSlideCopy = JSON.parse(JSON.stringify(previewCurrentSlide));
    let slidename = "";
    if (
      JSON.stringify(currentSlideCopy?.child) === "{}" &&
      currentSlideCopy?.master?.children?.length > 0
    ) {
      slidename = currentSlideCopy?.master?.children[0]?.slideid?.name?.replace(
        / /g,
        "_"
      );
      // console.log("slideNAmeFirstChild", slidename);
      currentSlideCopy.child = currentSlideCopy?.master?.children[0];
    } else {
      let currentChildIndex = currentSlideCopy?.child?.index - 1;
      let lastChild = currentSlideCopy.master.children.length - 1;
      if (currentChildIndex < lastChild) {
        slidename = currentSlide?.master?.children[
          currentChildIndex + 1
        ]?.slideid?.name.replace(/ /g, "_");
        currentSlideCopy.child =
          currentSlideCopy?.master?.children[currentChildIndex + 1];
      }
      currentSlideCopy.child =
        currentSlideCopy?.master?.children[currentChildIndex + 1];
    }
    // console.log(
    //   "url",
    //   `${PreviewEndPoint}preview/${appData?.deckId?.name}/${slidename}/index.html`
    // );
    const deckName = (
      appData?.deckId?.name ||
      deckData?.name ||
      "Deck"
    ).replace(/ /g, "_");
    const finalSlideName = slidename || "Slide1";
    SetCurrentURL(
      `${PreviewEndPoint}preview/${appData.userSub}/${deckName}/${finalSlideName}/index.html`
    );
    setPreviewCurrentSlide(currentSlideCopy);
  };
  const gotoPrevChildAndToParent = () => {
    let currentSlideCopy = JSON.parse(JSON.stringify(previewCurrentSlide));
    let currentChildIndex = currentSlideCopy?.child?.index - 1;
    let slidename = "";
    if (currentChildIndex > 0) {
      currentSlideCopy.child =
        currentSlideCopy.master.children[currentChildIndex - 1];
      slidename = (
        currentSlideCopy?.master?.children[currentChildIndex - 1]?.slideid
          ?.name || "Slide1"
      ).replace(/ /g, "_");
    } else if (currentChildIndex === 0) {
      currentSlideCopy.child = {};
      slidename = (currentSlideCopy?.master?.slideid?.name || "Slide1").replace(
        / /g,
        "_"
      );
    }
    setPreviewCurrentSlide(currentSlideCopy);
    const deckName = (
      appData?.deckId?.name ||
      deckData?.name ||
      "Deck"
    ).replace(/ /g, "_");
    SetCurrentURL(
      `${PreviewEndPoint}preview/${appData.userSub}/${deckName}/${slidename}/index.html`
    );
  };

  //To handle the master to master linking in desktop
  useEffect(() => {
    function scrollContainerToTop(container) {
      container.style.overflowY = "hidden";
      container.scrollTop = 0;

      requestAnimationFrame(() => {
        container.style.overflowY = "";
      });
    }

    const handler = (event) => {
      if (event.data?.action === "changeIframeSrc") {
        // document.getElementById("FrameID").src = event.data.src;
        const deckName = (
          appData?.deckId?.name ||
          deckData?.name ||
          "Deck"
        ).replace(/ /g, "_");
        SetCurrentURL(
          `${PreviewEndPoint}preview/${appData.userSub}/${deckName}/${event.data.src}/index.html`
        );
        const iframe = document.querySelector(".preview-container");
        scrollContainerToTop(iframe);
      }
    };

    window.addEventListener("message", handler);

    return () => {
      window.removeEventListener("message", handler);
    };
  }, []);

  return (
    <>
      <Dialog
        disableBackdropClick
        open={showPreview}
        onClose={() => setShowPreView(false)}
        className="preview exportAsModal"
        aria-labelledby="form-dialog-title"
        overlaystyle={{ backgroundColor: "transparent" }}
      >
        <div className="preview-dialog">
          <span>
            <span className="preview-title">
              {appData?.deckId?.type == 1
                ? "Template Preview"
                : "e-Detail Preview"}
              {appData?.deckId?.expired && (
                <span className="expired-label-preview-popup">
                  <span className="expireIconStyles">
                    <img src={expiredRestrictedIcon} />
                  </span>
                  Expired
                  <span>
                    {convertInDate(
                      appData?.deckId?.expired_at
                        ? appData?.deckId?.expired_at
                        : "",
                      "normal"
                    )}
                  </span>
                </span>
              )}
            </span>
            <span
              className="close-preview"
              onClick={() => setShowPreView(false)}
            >
              <img src={CancelIcon} alt="" className="preview-cancel-icon" />
            </span>
          </span>
        </div>
        <DialogContent style={{ padding: "0" }}>
          <div className="container-fulid previewModalVerticalMiddle">
            <div className="row g-0">
              <div className="col-md-12 d-flex">
                {" "}
                {/* text-end */}
                <div className="previewTopArrows">
                  <img
                    src={NewSlideRightArrowIcon}
                    className={
                      firstPage()
                        ? "disableNavigate left-icon"
                        : "preview-new-slide-left-icon left-icon"
                    }
                    alt=""
                    onClick={() => !firstPage() && gotoPrevious()}
                  />
                  <img
                    src={NewSlideRightArrowIcon}
                    width="26"
                    className={
                      lastPage()
                        ? "disableNavigate"
                        : "preview-new-slide-right-icon"
                    }
                    alt=""
                    onClick={() => !lastPage() && handleParent()}
                  />
                </div>
              </div>
              <div className="col-md-12 text-center">
                <div
                  className="preview-container customScrollBar"
                  style={{ position: "relative" }}
                >
                  <CircularProgressBar
                    isloading={previewLoading || !previewUrlReady}
                  />
                  {currentURL && previewUrlReady && (
                    <iframe
                      title={"preview"}
                      id="FrameID"
                      className="preview-iframe"
                      frameBorder="0"
                      key={currentURL} // Force reload when URL changes
                      src={currentURL}
                      onLoad={() => {
                        if (setLoading) {
                          setLoading(false);
                        }
                      }}
                    ></iframe>
                  )}
                </div>
              </div>
              <div className="col-md-12"></div>
            </div>
          </div>

          {/* <section className="preview-section">
            <div className="preview2">
              <div
                className="preview-content"
                id="preview-content-section"
                ref={sectionElement}
              >
                <div className="preview-left-right-arrow">
                  <img
                    src={NewSlideLeftArrowIcon}
                    className={
                      firstPage()
                        ? "disableNavigate"
                        : "preview-new-slide-left-icon"
                    }
                    alt=""
                    onClick={() => !firstPage() && gotoPrevious()}
                  />
                  <img
                    src={NewSlideRightArrowIcon}
                    className={
                      lastPage()
                        ? "disableNavigate"
                        : "preview-new-slide-right-icon"
                    }
                    alt=""
                    onClick={() => !lastPage() && handleParent()}
                  />
                </div>
                <div className="preview-modal-frame">
                  <div className=" preview-scroll customScrollBar">
                    <iframe
                      title={"preview"}
                      id="FrameID"
                      className="preview-iframe customScrollBar"
                      frameBorder="0"
                      style={{
                        transform: `scale(${canvasHeight})`, //translate(${grapesjsWidth}px, 0px)
                      }}
                      sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                      src={currentURL}
                    ></iframe>
                  </div>
                </div>
                <div className="row preview-up-down-arrow">
                  <span className="preview-down-arrow">
                    <img
                      src={NewSlideLeftArrowIcon}
                      className={"down-arrow-disabled"}
                      // className={
                      //   inParent(previewCurrentSlide)
                      //     ? "down-arrow-disabled"
                      //     : "preview-down-arrow-icon"
                      // }
                      alt=""
                      // onClick={
                      //   !inParent(previewCurrentSlide) &&
                      //   gotoPrevChildAndToParent
                      // }
                    />
                  </span>
                  <span className="preview-up-arrow">
                    <img
                      src={NewSlideRightArrowIcon}
                      className={"down-arrow-disabled"}
                      // lastChild(previewCurrentSlide)
                      //   ? "down-arrow-disabled"
                      //   : "preview-up-arrow-icon"
                      // }
                      alt=""
                      // onClick={
                      //   !lastChild(previewCurrentSlide) && gotoFirstAndNextChild
                      // }
                    />
                  </span>
                </div>
              </div>
            </div>
          </section> */}
        </DialogContent>
      </Dialog>
    </>
  );
}
